export default [
    {
        path: '/sellers-users-list',
        component: () => import('../components/UsersParent.vue'),
        children: [
            {
                path: '/sellers-users-list',
                component: () => import('../components/SubscribedUserList.vue'),
                name: 'sellers-users-list',
                meta: {
                }
            },
            {
                path: '/subscribed-view-user/:id',
                component: () => import('../components/partials/SubscribedViewUser.vue'),
                name: 'subscribed-view-user',
                meta: {                  
                }
            },
        ]
    },

]